"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RectanglePainter = void 0;
var ShapePainter_1 = require("../ShapePainter");
var round_1 = require("../../../util/round");
/**
 * Implements drawing-related operations for rectangles.
 */
var RectanglePainter = /** @class */ (function (_super) {
    __extends(RectanglePainter, _super);
    function RectanglePainter() {
        var _this = _super.call(this, "rectangle") || this;
        _this.baseWidthOf = function (object) { return object.width; };
        _this.baseHeightOf = function (object) { return object.height; };
        return _this;
    }
    RectanglePainter.prototype.tracePath = function (ctx, store, object) {
        var width = this.scaledBaseWidthOf(object);
        var height = this.scaledBaseHeightOf(object);
        ctx.rect(0, 0, round_1.round(object, width), round_1.round(object, height));
    };
    return RectanglePainter;
}(ShapePainter_1.ShapePainter));
exports.RectanglePainter = RectanglePainter;
//# sourceMappingURL=RectanglePainter.js.map